import Clazz from '../../common/Clazz';

/**
 * 检查模块的总控制器
 */
export default class CheckController extends Clazz {
    /**
     * 检查控制器，必须绑定到已经加入map对象的编辑工具
     * @param {*} editTool 编辑工具
     * @param {*} options  可选项
     */
    constructor(map, options) {
        super(options);
 
        /**
         * 运行时检查规则
         * @type {array}
         */
        this.runtimeRules = [];
        /**
         * 操作完成时的检查规则
         * @type {array}
         */
        this.postRules = [];
        /**
         * 地图对象
         * @type {object}
         */
        this.map = map;
        /**
         * 要素选择器，从地图对象中获取
         * @type {object}
         */
        this.featureSelector = map.FeatureSelector;
    }

    /**
     * 向控制器中添加规则
     * @param {object} rule CheckRule对象
     * @param {number} situation 执行时机，1：运行时；2.工具完成finish时
     */
    add(rule, situation = 1) {
        let rules;
        if (situation === 1) {
            rules = this.runtimeRules;
        } else if (situation === 2) {
            rules = this.postRules;
        }

        if (rules) {
            const existIndex = rules.indexOf(rule);
            if (existIndex >= 0) {
                return;
            }

            rule.onAdd(this);

            rules.push(rule);
        }
    }

    /**
     * 从控制器中删除指定的规则
     * @param {object} rule CheckRule对象
     * @param {number} situation 执行时机，1：运行时；2.工具完成finish时
     */
    delete(rule, situation = 1) {
        let rules;
        if (situation === 1) {
            rules = this.runtimeRules;
        } else if (situation === 2) {
            rules = this.postRules;
        }

        const existIndex = rules.indexOf(rule);
        if (existIndex >= 0) {
            rules[existIndex].onRemove();

            rules.splice(existIndex, 1);
        }
    }

    /**
     * 清空控制器中的规则
     */
    clear() {
        this.runtimeRules.forEach(item => {
            item.onRemove();
        });

        this.postRules.forEach(item => {
            item.onRemove();
        });

        this.runtimeRules = [];
        this.postRules = [];
    }

    /**
     * 执行运行时检查
     * @param {object} editResult 编辑结果对象
     */
    runtimeCheck(editResult) {
        const checkResults = this.check(editResult, this.runtimeRules);
        checkResults.forEach(it => {
            it.situation = 1;
        });

        return checkResults;
    }

    /**
     * 执行编辑完成时检查
     * @param {object} editResult 编辑结果对象
     */
    postCheck(editResult) {
        const checkResults = this.check(editResult, this.postRules);
        checkResults.forEach(it => {
            it.situation = 2;
        });

        return checkResults;
    }

    /**
     * 执行编辑完成时检查
     * @param {object} editResult 编辑结果对象
     * @param {array}  rules      检查规则
     */
    check(editResult, rules) {
        const checkResults = [];
        rules.forEach(rule => {
            const results = rule.check(editResult);
            checkResults.push(...results);
        });

        return checkResults;
    }
}
